import React from 'react';
import LoadingWrapper from './LoadingWrapper';

const ChipWrapper = (loading: boolean): React.ElementType =>
  // eslint-disable-next-line react/display-name
  React.forwardRef((props, ref) => <LoadingWrapper {...props} loading={loading} forwardedRef={ref} />);

export default ChipWrapper;
